// extracted by mini-css-extract-plugin
export default {"lessonStatusContainer":"CategoryLessonStatus_lessonStatusContainer__Phf0U","imgContainer":"CategoryLessonStatus_imgContainer__x-RmF","bottom":"CategoryLessonStatus_bottom__tbn9I"};